import { useState } from 'react';

export const useRowLoaders = () => {
  const [loadingRows, setLoadingRows] = useState({}); // { [rowId]: boolean }

  const setLoading = (rowId, isLoading=true) => {
    setLoadingRows(prev => ({
      ...prev,
      [rowId]: isLoading,
    }));
  };

  const clearLoading = (rowId) => {
    setLoadingRows(prev => {
      const updated = { ...prev };
      delete updated[rowId];
      return updated;
    });
  };

  const clearAllLoaders = () => {
    setLoadingRows({});
  };

  const isRowLoading = (rowId) => !!loadingRows[rowId];

  return {
    setLoading,
    clearLoading,     // remove a specific ID
    clearAllLoaders,  // remove all
    isRowLoading,
    loadingRows,
  };
};
